<div class="textarea-container" [class.has-error]="touched && required && !value">
  <label *ngIf="label" [for]="id || name" class="form-label">
    {{ label }}
    <span *ngIf="required" class="required-indicator">*</span>
  </label>

  <div class="textarea-wrapper">
    <!-- [maxlength]="maxlength"
      [minlength]="minlength" -->
    <textarea
      [id]="id || name"
      [name]="name"
      [placeholder]="placeholder"
      [required]="required"
      [disabled]="disabled"
      [readonly]="readonly"
      [rows]="rows"
      [cols]="cols"
      [autocomplete]="autocomplete"
      [class]="'textarea-field ' + class"
      [value]="value"
      (input)="onInput($event)"
      (blur)="onBlur()"
      (focus)="onFocus()"
    >
    </textarea>

    <div *ngIf="maxlength" class="character-count">
      <span [class]="getCharacterCountClass()"> {{ characterCount }}/{{ maxlength }} </span>
      <span *ngIf="getRemainingCharacters() <= 10" class="remaining-chars"> ({{ getRemainingCharacters() }} remaining) </span>
    </div>
  </div>

  <div *ngIf="touched && required && !value" class="error-message">This field is required.</div>

  <div *ngIf="touched && minlength && characterCount < minlength" class="error-message">Minimum {{ minlength }} characters required.</div>
</div>
